import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useInfiniteHits } from "react-instantsearch";
import NoResultsMessage from "../../algolia_search/no_results_message";
import SearchLoadingCards from "./search_loading_cards";
import ExpertSkeletonPage from "./expert_skeleton_page";
import useInfiniteScroll from "../../hooks/use_infinite_scroll";
import EmptyResults from "./empty_results";
import ExpertCardGrid from "../card/ExpertCardGrid";
import ExpertCardList from "../card/ExpertCardList";
import expertListActionColumnWidth from "../card/listActionColumn";
import { listHeaderRowStyle } from "../../source_directory/utils";

function InfiniteHits({ viewMode = "grid" }) {
  const { hits, isLastPage, showMore } = useInfiniteHits();
  const hasMore = !isLastPage;

  // Ignore scrollContainerRef since we want to use root as the scrolling container
  const [lastTriggeredAt, scrollTriggerRef] = useInfiniteScroll({ hasMore });

  // Effect to refine results when infinite scroll triggers
  useEffect(() => {
    if (lastTriggeredAt > 0) showMore();
  }, [lastTriggeredAt, showMore]);

  const customMessage = globalThis.Qwoted.CURRENT_USER_ID ? <EmptyResults /> : undefined;

  if (viewMode === "list") {
    // A signed-in viewer can message most experts, so reserve the can-message action width.
    const isSignedIn = !!globalThis.Qwoted.CURRENT_USER_ID;
    const actionColumnWidth = expertListActionColumnWidth(isSignedIn);

    return (
      <>
        <NoResultsMessage customMessage={customMessage} hits={hits} />
        {hits.length > 0 && (
          <div className="sd-list-header-row" style={listHeaderRowStyle}>
            <span style={{ flex: "0 0 220px" }}>Name</span>
            <span style={{ flex: "0 0 130px" }}>Location</span>
            <span style={{ flex: 1 }}>Bio</span>
            <span aria-hidden="true" style={{ flex: `0 0 ${actionColumnWidth}px` }} />
          </div>
        )}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <SearchLoadingCards />
          {hits.map((expert) => (
            <ExpertCardList key={expert.objectID} hit={expert} />
          ))}
        </div>
        {hasMore && <div ref={scrollTriggerRef} />}
      </>
    );
  }

  return (
    <>
      <NoResultsMessage customMessage={customMessage} hits={hits} />
      <div className="sd-cards-grid">
        <SearchLoadingCards />
        {hits.map((expert) => (
          <ExpertCardGrid key={expert.objectID} hit={expert} />
        ))}
      </div>
      {hasMore && (
        <div ref={scrollTriggerRef} className="sd-cards-grid sd-cards-grid--loading-more">
          <ExpertSkeletonPage numberOfCards={3} singleRow />
        </div>
      )}
    </>
  );
}

InfiniteHits.propTypes = {
  viewMode: PropTypes.oneOf(["grid", "list"]),
};

export default InfiniteHits;
